module.exports = __webpack_public_path__ + "public/img/Strategi Pemasaran Untuk Spesialis Pengembangan Bisnis.0294d039.png";